export default __webpack_public_path__ + "static/media/blog-img249.dafca103.jpg";